// Import packages
import React, {useEffect, useState} from "react";

// Import styles
import "./progress-bar.scss";

export function ProgressBar(props) {
    const [animate, setAnimate] = useState(false);
    // console.log(props.sliderLenght,'props.slideIndex')

    useEffect(() => {
        if(props.sliderCircleEnded ){
            setAnimate(false);
        }else{
            setAnimate(true);
        }
    }, [props.sliderCircleEnded ]);

    return <div className="progress-wrapper">
        {
            props?.slider?.map((item,index)=>{
                return <div className={'progress-bar'} style={{width: (100/props.slider?.length - 1) + '%'}}>
                    {
                        index === props.slideIndex ? <span className={`stroke ${animate ? 'animate' : ''}`}/> : ''
                    }
                </div>
            })
        }
    </div>
}
